/**
 * Commute Survey Service — admin CRUD + public submission.
 */
import axios from 'axios';
import { getToken } from './authService';

const BACKEND = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
const API_URL = `${BACKEND}/api/commute-surveys`;

const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const createSurvey = async (body) => {
  const res = await axios.post(API_URL, body, authHeaders());
  return res.data;
};

export const listSurveys = async () => {
  const res = await axios.get(API_URL, authHeaders());
  return res.data;
};

export const getSurveySubmissions = async (surveyId) => {
  const res = await axios.get(`${API_URL}/${surveyId}/submissions`, authHeaders());
  return res.data;
};

export const closeSurvey = async (surveyId) => {
  const res = await axios.post(`${API_URL}/${surveyId}/close`, {}, authHeaders());
  return res.data;
};

// PUBLIC — no auth
export const getPublicSurvey = async (token) => {
  const res = await axios.get(`${API_URL}/public/${token}`);
  return res.data;
};

export const submitCommuteResponse = async (token, payload) => {
  const res = await axios.post(`${API_URL}/public/${token}/submissions`, payload);
  return res.data;
};
